(() => {
  function updateNavigation() {
    document.querySelectorAll('[data-magazine-category-nav]').forEach((nav) => {
      const list = nav.querySelector('.amazfit-magazine__category-list');
      if (!list) return;
      if (nav.dataset.magazineNavigationMode === 'blocks') {
        list.querySelectorAll('a').forEach((link) => {
          if (link.origin !== window.location.origin || link.pathname !== window.location.pathname) return;
          const categoryMatch = link.hash.match(/^#magazine-category-template--\d+__(.+)$/);
          if (!categoryMatch) return;
          const category = Array.from(document.querySelectorAll('[data-amazfit-magazine-category]'))
            .find((element) => element.id.endsWith(`__${categoryMatch[1]}`));
          if (!category || link.hash === `#${category.id}`) return;
          if (link.getAttribute('href').startsWith('#')) {
            link.setAttribute('href', `#${category.id}`);
          } else {
            link.hash = `#${category.id}`;
          }
        });
        nav.hidden = !list.children.length;
        return;
      }
      list.replaceChildren();
      document.querySelectorAll('[data-amazfit-magazine-category]').forEach((category) => {
        if (!category.id || !category.dataset.magazineCategoryTitle || category.closest('[hidden]')) return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'amazfit-magazine__category-link';
        link.href = `#${category.id}`;
        link.textContent = category.dataset.magazineCategoryTitle;
        item.appendChild(link);
        list.appendChild(item);
      });
      nav.hidden = !list.children.length;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateNavigation, { once: true });
  } else {
    updateNavigation();
  }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((event) => {
    document.addEventListener(event, () => requestAnimationFrame(updateNavigation));
  });
})();
